import { render, staticRenderFns } from "./CardEditUserRoles.vue?vue&type=template&id=070ea594&"
import script from "./CardEditUserRoles.vue?vue&type=script&lang=js&"
export * from "./CardEditUserRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports